import { configureStore } from "@reduxjs/toolkit";
import balanceReducer from "../features/balance/totalBalanceSlice";
import filterReducer from "../features/filter/filterSlice";
import transactionReducer from "../features/transaction/transactionSlice";

export const store = configureStore({
  reducer: {
    transaction: transactionReducer,
    filter: filterReducer,
    balance: balanceReducer,
  },
});
